<div class="page" *ngIf="loading">
  <div class="page__inner">
    <div class="state-card">
      <div class="state-card__spinner" aria-hidden="true"></div>
      <h2>Préparation du parcours…</h2>
      <p>Chargement des étapes de souscription.</p>
    </div>
  </div>
</div>

<div class="page" *ngIf="!loading && error">
  <div class="page__inner">
    <div class="state-card state-card--error">
      <mat-icon class="state-card__icon">error_outline</mat-icon>
      <h2>Souscription indisponible</h2>
      <p>{{ error }}</p>
      <a class="btn btn--primary" routerLink="/accueil" fragment="produits">Retour aux produits</a>
    </div>
  </div>
</div>

<div class="page page--ready" *ngIf="!loading && !error && catalog && technicalProduct && viewPhase === 'success'">
  <div class="page__inner">
    <div class="thanks">
      <div class="thanks__badge" aria-hidden="true">
        <mat-icon>thumb_up_alt</mat-icon>
      </div>
      <h1>Merci !</h1>
      <p class="thanks__subtitle">Souscription confirmée</p>

      <div class="thanks__status">
        <span class="thanks__status-icon" aria-hidden="true">
          <mat-icon>check_circle_outline</mat-icon>
        </span>
        <p>Votre souscription à {{ successProductName }} a été effectuée avec succès</p>
      </div>

      <div class="thanks__details">
        <div class="thanks__details-head">
          <mat-icon>verified_user</mat-icon>
          <span>Détails de la police</span>
        </div>

        <div class="thanks__period" *ngIf="guaranteePeriodLabel">
          <span>Période de garantie</span>
          <strong>{{ guaranteePeriodLabel }}</strong>
        </div>

        <div class="thanks__row" *ngIf="successPolicyNumber">
          <span>Numéro de la police</span>
          <strong>{{ successPolicyNumber }}</strong>
        </div>
        <div class="thanks__row" *ngIf="selectedPrimeLabel">
          <span>Prime totale</span>
          <strong>{{ selectedPrimeLabel }}</strong>
        </div>

        <button
          type="button"
          class="thanks__doc"
          *ngIf="canDownloadCp"
          (click)="downloadConditionsParticulieres()"
          [disabled]="cpDownloading">
          <mat-icon>picture_as_pdf</mat-icon>
          {{ cpDownloading ? 'Téléchargement…' : 'Conditions particulières' }}
        </button>
        <button
          type="button"
          class="thanks__doc"
          *ngIf="canDownloadAttestation"
          (click)="downloadAttestation()"
          [disabled]="cpDownloading">
          <mat-icon>picture_as_pdf</mat-icon>
          {{ cpDownloading ? 'Téléchargement…' : 'Attestation' }}
        </button>
      </div>

      <button type="button" class="btn btn--primary thanks__ok" (click)="goHome()">OK</button>
    </div>
  </div>
</div>

<div class="page page--ready" *ngIf="!loading && !error && catalog && technicalProduct && viewPhase === 'recap'">
  <div class="page__inner">
    <button type="button" class="back back--button" (click)="backToWizard()">
      <mat-icon>chevron_left</mat-icon>
      Modifier le parcours
    </button>

    <header class="hero hero--recap">
      <div class="hero__visual" *ngIf="productImageUrl">
        <img [src]="productImageUrl" [alt]="catalog.name" />
      </div>
      <div class="hero__text">
        <span class="hero__eyebrow">Récapitulatif</span>
        <h1 class="hero__title">{{ catalog.name }}</h1>
        <p class="hero__subtitle">{{ technicalProduct.name }}</p>
      </div>
    </header>

    <section class="recap-panel">
      <div class="recap-panel__summary recap-panel__summary--single">
        <div>
          <span>Prime TTC</span>
          <strong class="recap-panel__prime">{{ recapPrimeTtcLabel || '—' }}</strong>
        </div>
      </div>

      <div class="recap-panel__docs" *ngIf="canDownloadCp">
        <span class="recap-panel__docs-label">Documents</span>
        <button
          type="button"
          class="recap-doc-btn"
          (click)="downloadConditionsParticulieres()"
          [disabled]="cpDownloading"
          aria-label="Télécharger les conditions particulières"
        >
          <span class="recap-doc-btn__icon" aria-hidden="true">PDF</span>
          <span class="recap-doc-btn__label">CP.</span>
        </button>
      </div>

      <p class="recap-info" *ngIf="infoMessage">{{ infoMessage }}</p>

      <div class="recap-panel__accordions">
        <mat-accordion class="recap-accordion" multi="false">
          <mat-expansion-panel class="recap-panel-item" *ngIf="recapPolicyRows.length" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="recap-panel-item__bar" aria-hidden="true"></span>
                Police
              </mat-panel-title>
            </mat-expansion-panel-header>

            <dl class="recap-item-list">
              <div class="recap-item" *ngFor="let row of recapPolicyRows">
                <dt>{{ row.label }} :</dt>
                <dd>{{ row.value }}</dd>
              </div>
            </dl>
          </mat-expansion-panel>

          <mat-expansion-panel class="recap-panel-item" *ngIf="showRecapInsuredSection">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="recap-panel-item__bar" aria-hidden="true"></span>
                Assuré
              </mat-panel-title>
            </mat-expansion-panel-header>

            <dl class="recap-item-list">
              <div class="recap-item" *ngFor="let row of recapInsuredRows">
                <dt>{{ row.label }} :</dt>
                <dd>{{ row.value }}</dd>
              </div>
            </dl>
          </mat-expansion-panel>

          <mat-expansion-panel class="recap-panel-item" *ngIf="recapGuaranteeRows.length">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="recap-panel-item__bar" aria-hidden="true"></span>
                Garanties
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="recap-guarantees-table-wrap">
              <table class="recap-guarantees-table">
                <thead>
                  <tr>
                    <th>Garantie</th>
                    <th>Capital</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let row of recapGuaranteeRows; let i = index"
                    [class.recap-guarantees-table__alt]="i % 2 === 0"
                  >
                    <td>{{ row.label }}</td>
                    <td>{{ row.capital }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel class="recap-panel-item" *ngIf="recapBeneficiarySections.length">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="recap-panel-item__bar" aria-hidden="true"></span>
                {{ beneficiarySectionTitle }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="recap-beneficiary-list">
              <article class="recap-beneficiary-card" *ngFor="let section of recapBeneficiarySections">
                <dl class="recap-item-list recap-item-list--compact">
                  <div class="recap-item" *ngFor="let row of section.rows">
                    <dt>{{ row.label }} :</dt>
                    <dd>{{ row.value }}</dd>
                  </div>
                </dl>
              </article>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel class="recap-panel-item" *ngIf="recapRachatRows.length">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="recap-panel-item__bar" aria-hidden="true"></span>
                Valeurs de rachat
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="recap-guarantees-table-wrap recap-guarantees-table-wrap--scroll">
              <table class="recap-guarantees-table">
                <thead>
                  <tr>
                    <th>Année</th>
                    <th>Valeur</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let row of recapRachatRows; let i = index"
                    [class.recap-guarantees-table__alt]="i % 2 === 0"
                  >
                    <td>{{ row.year }}</td>
                    <td>{{ row.value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </section>

    <footer class="actions">
      <button type="button" class="btn btn--ghost" (click)="backToWizard()" [disabled]="submitting">
        Retour
      </button>
      <button type="button" class="btn btn--primary" (click)="startPayment()" [disabled]="submitting || paymentAmount <= 0">
        <mat-icon>payments</mat-icon>
        {{ submitting ? 'Chargement…' : 'Payer' }}
      </button>
    </footer>
  </div>
</div>

<div class="page page--ready" *ngIf="!loading && !error && catalog && technicalProduct && viewPhase === 'payment'">
  <div class="page__inner">
    <button type="button" class="back back--button" (click)="viewPhase = 'recap'" [disabled]="submitting">
      <mat-icon>chevron_left</mat-icon>
      Retour au récapitulatif
    </button>

    <header class="hero hero--recap">
      <div class="hero__visual" *ngIf="productImageUrl">
        <img [src]="productImageUrl" [alt]="catalog.name" />
      </div>
      <div class="hero__text">
        <span class="hero__eyebrow">Paiement mobile</span>
        <h1 class="hero__title">{{ catalog.name }}</h1>
        <p class="hero__subtitle">{{ technicalProduct.name }}</p>
      </div>
    </header>

    <app-subscription-payment
      [amount]="paymentAmount"
      [currencyLabel]="currencyLabel"
      [policyNumber]="policyNumber"
      [productId]="technicalProduct.id"
      [productName]="catalog.name"
      (paymentCompleted)="onPaymentCompleted($event)"
    ></app-subscription-payment>
  </div>
</div>

<div class="page page--ready" *ngIf="!loading && !error && catalog && technicalProduct && viewPhase === 'wizard'">
  <div class="page__inner" *ngIf="currentPage as page">
    <a class="back" [routerLink]="backLink">
      <mat-icon>chevron_left</mat-icon>
      Retour au produit
    </a>

    <header class="hero">
      <div class="hero__visual" *ngIf="productImageUrl">
        <img [src]="productImageUrl" [alt]="catalog.name" />
      </div>
      <div class="hero__text">
        <span class="hero__eyebrow">Souscription</span>
        <h1 class="hero__title">{{ catalog.name }}</h1>
        <p class="hero__subtitle">
          {{ technicalProduct.name }}
          <span *ngIf="technicalProduct.code"> · {{ technicalProduct.code }}</span>
        </p>
      </div>
      <div class="hero__meta">
        <span class="badge badge--accent">{{ operationLabel }}</span>
        <span class="badge badge--muted">Étape {{ currentStep + 1 }} / {{ pages.length }}</span>
      </div>
    </header>

    <nav class="progress" aria-label="Progression de la souscription">
      <div class="progress__track" aria-hidden="true">
        <div class="progress__fill" [style.width.%]="progressPercent"></div>
      </div>

      <ol class="progress__steps">
        <li
          class="progress__step"
          *ngFor="let p of pages; let i = index; trackBy: trackByPageId"
          [class.progress__step--active]="i === currentStep"
          [class.progress__step--done]="i < currentStep">
          <div class="progress__btn" [attr.aria-current]="i === currentStep ? 'step' : null">
            <span class="progress__marker" aria-hidden="true"></span>
            <span class="progress__label">{{ stepLabel(p, i) }}</span>
          </div>
        </li>
      </ol>
    </nav>

    <section class="panel" [class.panel--formule]="isFormuleStep">
      <div class="panel__head" *ngIf="!isFormuleStep && page.operationType">
        <div class="panel__chip">
          Type d’opération : <strong>{{ page.operationType }}</strong>
          <span *ngIf="page.canFetch"> · calcul automatique possible</span>
        </div>
      </div>

      <div class="panel__divider" aria-hidden="true" *ngIf="!isFormuleStep"></div>

      <p class="formule-hint" *ngIf="isFormuleStep">
        Choisissez votre formule pour continuer
      </p>

      <div class="banner" *ngIf="infoMessage">
        <mat-icon>info</mat-icon>
        <span>{{ infoMessage }}</span>
      </div>

      <div class="summary-strip" *ngIf="hasTwoCentralizedElements(page)">
        <div>
          <span>Formule</span>
          <strong>{{ selectedQuittance?.quittance?.LIBFORCO || firstFormuleLabel }}</strong>
        </div>
        <div>
          <span>Prime</span>
          <strong>{{ selectedPrimeLabel || 'Calculée à l’étape précédente' }}</strong>
        </div>
      </div>

      <app-subscription-insured
        *ngIf="hasCustomInsured(page) && technicalProduct"
        [page]="page"
        [product]="technicalProduct"
        [initData]="initData"
        [assures]="assures"
        (assuresChange)="onAssuresChange($event)">
      </app-subscription-insured>

      <form class="form" *ngIf="currentForm as form" [formGroup]="form" (ngSubmit)="continue()" (input)="clearValidationFeedback()">
        <ng-container *ngFor="let field of displayFields(page); trackBy: trackByFieldId">
        <div
          class="field"
          [class.field--error]="fieldControl(field.name).invalid && (fieldControl(field.name).touched || displayValidationErrors)">
          <label
            class="field__label"
            [attr.for]="field.id"
            *ngIf="fieldType(field) !== 'card' && fieldType(field) !== 'toggle'">
            {{ field.label || field.name }}
            <span class="field__req" *ngIf="isRequired(field)">*</span>
          </label>

          <div class="field__box" *ngIf="fieldType(field) === 'select' && !usesFormuleOptions(field)">
            <select class="field__input" [formControlName]="field.name" [id]="field.id">
              <option value="">Choisir…</option>
              <option *ngFor="let opt of selectOptions(field)" [value]="optionValue(opt)">
                {{ formatOptionLabel(opt) }}
              </option>
            </select>
            <mat-icon class="field__affix" aria-hidden="true">expand_more</mat-icon>
          </div>

          <div class="field__box" *ngIf="fieldType(field) === 'date'">
            <input
              class="field__input"
              type="date"
              [formControlName]="field.name"
              [id]="field.id"
              placeholder="jj/mm/aaaa" />
            <mat-icon class="field__affix" aria-hidden="true">calendar_today</mat-icon>
          </div>

          <div
            class="field__box"
            *ngIf="fieldType(field) === 'number' || fieldType(field) === 'numeric'">
            <input
              class="field__input"
              type="number"
              [formControlName]="field.name"
              [id]="field.id"
              inputmode="decimal" />
          </div>

          <app-subscription-bank-details
            *ngIf="fieldType(field) === 'toggle'"
            [formControlName]="field.name"
            [fieldId]="field.id"
            [banks]="bankOptions">
          </app-subscription-bank-details>

          <div class="card-options" [class.card-options--formule]="isFormuleStep" *ngIf="fieldType(field) === 'card'">
            <div
              class="card-option"
              *ngFor="let opt of selectOptions(field); let i = index"
              [class.card-option--active]="fieldControl(field.name).value === optionValue(opt)">
              <button
                type="button"
                class="card-option__main"
                (click)="selectFormuleOption(field.name, opt, i)">
                <span class="card-option__logo" aria-hidden="true">
                  <img *ngIf="optionImageUrl" [src]="optionImageUrl" alt="" />
                  <mat-icon *ngIf="!optionImageUrl">verified_user</mat-icon>
                </span>
                <span class="card-option__body">
                  <span class="card-option__label">{{ formatOptionLabel(opt) }}</span>
                  <span class="card-option__prime" *ngIf="opt.primeLabel">{{ opt.primeLabel }}</span>
                  <span class="card-option__prime card-option__prime--pending" *ngIf="!opt.primeLabel">
                    Prime après devis
                  </span>
                </span>
                <span
                  class="card-option__check"
                  [class.card-option__check--on]="fieldControl(field.name).value === optionValue(opt)">
                  <mat-icon>{{
                    fieldControl(field.name).value === optionValue(opt) ? 'check' : 'chevron_right'
                  }}</mat-icon>
                </span>
              </button>

              <button
                type="button"
                class="card-option__details"
                *ngIf="canShowOptionDetails"
                (click)="openOptionDetails(i); $event.stopPropagation()">
                <mat-icon>add_circle_outline</mat-icon>
                Détails
              </button>
            </div>

            <p class="card-options__empty" *ngIf="!selectOptions(field).length">
              Aucune formule disponible. Complétez d’abord l’étape devis.
            </p>
          </div>

          <div
            class="field__box"
            *ngIf="fieldType(field) === 'typeinsurance'">
            <select class="field__input" [formControlName]="field.name" [id]="field.id">
              <option value="">Choisir…</option>
              <option *ngFor="let opt of selectOptions(field)" [value]="optionValue(opt)">
                {{ formatOptionLabel(opt) }}
              </option>
            </select>
            <mat-icon class="field__affix" aria-hidden="true">expand_more</mat-icon>
          </div>

          <div
            class="field__box"
            *ngIf="!['select','date','number','numeric','toggle','card','typeinsurance'].includes(fieldType(field))">
            <input
              class="field__input"
              type="text"
              [formControlName]="field.name"
              [id]="field.id" />
          </div>

          <ul class="field__errors" *ngIf="fieldErrors(field).length">
            <li *ngFor="let err of fieldErrors(field)">
              <span aria-hidden="true">•</span> {{ err }}
            </li>
          </ul>
        </div>
        </ng-container>

        <p class="empty-fields" *ngIf="!displayFields(page).length">
          Aucun champ à saisir sur cette étape
          <span *ngIf="(page.operationType || '').toUpperCase() === 'FORMULE'">
            (sélection de formule).
          </span>
        </p>
      </form>
    </section>

    <footer class="actions" [class.actions--formule]="isFormuleStep">
      <button
        type="button"
        class="btn btn--ghost"
        [disabled]="currentStep === 0 || submitting"
        (click)="previous()">
        Retour
      </button>

      <button
        *ngIf="showContinueButton"
        type="button"
        class="btn btn--primary"
        [disabled]="submitting"
        (click)="continue()">
        <span *ngIf="!submitting">{{ isLastStep ? 'Voir le récapitulatif' : 'Continuer' }}</span>
        <span *ngIf="submitting">Traitement…</span>
      </button>
    </footer>
  </div>
</div>

<!-- Détails formule (bottom sheet) -->
<div class="details-sheet" *ngIf="detailsIndex !== null" (click)="closeOptionDetails()">
  <div class="details-sheet__panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="details-sheet-title">
    <div class="details-sheet__handle" aria-hidden="true"></div>
    <h3 class="details-sheet__title" id="details-sheet-title">Garanties</h3>
    <p class="details-sheet__formula" *ngIf="detailsOption?.LABEL">{{ detailsOption?.LABEL }}</p>
    <ul class="details-sheet__list" *ngIf="detailsGuarantees.length">
      <li *ngFor="let g of detailsGuarantees">
        <span class="details-sheet__icon" aria-hidden="true">
          <mat-icon>verified_user</mat-icon>
        </span>
        <span class="details-sheet__meta">
          <span class="details-sheet__guarantee">{{ g.label }}</span>
          <span class="details-sheet__capital-label">Capital assuré</span>
        </span>
        <span class="details-sheet__capital">{{ g.capital }}</span>
      </li>
    </ul>
    <p class="details-sheet__empty" *ngIf="!detailsGuarantees.length">
      Aucune garantie disponible
    </p>
    <button type="button" class="btn btn--primary details-sheet__close" (click)="closeOptionDetails()">
      Fermer
    </button>
  </div>
</div>

<div
  class="subscription-overlay"
  *ngIf="(submitting && viewPhase === 'payment') || (cpDownloading && viewPhase === 'success')">
  <div class="subscription-overlay__card">
    <div class="state-card__spinner" aria-hidden="true"></div>
    <p>{{ cpDownloading && viewPhase === 'success' ? 'Téléchargement en cours...' : 'Validation en cours…' }}</p>
  </div>
</div>

<app-error-info-modal
  [open]="!!errorModalMessage"
  [message]="errorModalMessage || ''"
  [showRetry]="errorModalCanRetry"
  (closed)="closeErrorModal()"
  (retried)="retryErrorModal()">
</app-error-info-modal>
